import styled from 'styled-components';

const CategoryItemStyle = styled.div`
	--paddingText: var(--sp4x);

	min-width: var(--widthItem);
	overflow: hidden;
	border-radius: 20px;
	border: 1px solid var(--neutral600);

	.link-wrapper {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	.text-block {
		flex: 1;
		padding: var(--paddingText);
	}

	.image-cont {
		--proportion: var(--sizeImage);

		width: var(--sizeImage);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--paddingText: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--paddingText: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--paddingText: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--paddingText: var(--sp1-5x);
	}
`;

export default CategoryItemStyle;
